/**
 * Created by chenjia on 2017/4/8.
 */
let Config = require('../../Config/Config');

let specialChooseModel = {
    ajaxGetFlagImg: function (data, success, error) {
        $.ajax({
            url: Config.serviceInterface.getFlagImg,
            data: data,
            method: 'post',
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    if ($.isFunction(success)) {
                        success(data.data);
                    }
                } else {
                    if ($.isFunction(error)) {
                        error();
                    }
                }
            }
        });
    },
    ajaxGetCommentNum: function (data, success, error) {
        $.ajax({
            url: Config.serviceInterface.getCommentNum,
            data: data,
            method: "post",
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    if ($.isFunction(success)) {
                        success(data.data);
                    }
                } else {
                    if ($.isFunction(error)) {
                        error();
                    }
                }
            }
        });
    },
    ajaxGetCategorySkus: function (data, success, error) {
        if (Config.debug) {
            let mockData =
                {
                    "data": {
                        "skus": [
                            {
                                "sales": 988,
                                "skuName": "欧顿(OUDUN)手表 男士多功能时尚商务三眼日历运动腕表防水钢带皮带石英男表 3011黑圈黑钢带O",
                                "sku": "234368",
                                "skuImg": "http://img12.360buyimg.com/test/jfs/t34/212/485373045/48561/712c9e5b/58e78fdcN41c2c50e.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            },
                            {
                                "sales": 765,
                                "skuName": "阿帕琦IK 手表 镂空全自动夜光机械表 男表 防水商务韩版时尚休闲腕表学生运动男士手表 金边白面金机心",
                                "sku": "267713",
                                "skuImg": "http://img14.360buyimg.com/test/jfs/t34/214/477281906/48561/712c9e5b/58e78fe2N42f2c0bc.jpg"
                            }
                        ],
                        "banner": {
                            "bannerLink": "https://sale.jd.com/m/act/4I85P6vlHbsXgm.html",
                            "bannerImg": "../tmp/jingxuan6.jpg"
                        }
                    },
                    "success": true,
                    "errorMsg": ""
                };
            success(mockData.data);
        } else {
            $.ajax({
                url: Config.serviceInterface.getCategorySkus,
                data: data,
                method: "post",
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        if ($.isFunction(success)) {
                            success(data.data);
                        }
                    } else {
                        if ($.isFunction(error)) {
                            error();
                        }
                    }
                }
            });
        }
    },
    ajaxAttentionProduct: function (data, success, error) {
        if(Config.debug) {
            success(true);
        } else {
            $.ajax({
                url: Config.serviceInterface.productFollow,
                data: data,
                method: "post",
                dataType: "jsonp",
                success: function (data) {
                    if (data.success) {
                        if ($.isFunction(success)) {
                            success(data.result);
                        }
                    } else {
                        if ($.isFunction(error)) {
                            error();
                        }
                    }
                }
            });
        }
    }
};
module.exports = specialChooseModel;


// WEBPACK FOOTER //
// ./src/js/model/specialChooseModel/specialChooseModel.js